exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-222127ce]{width:100%;border-collapse:collapse;border:1px solid #dee2e6}table tbody[data-v-222127ce],table td[data-v-222127ce],table tfoot[data-v-222127ce],table th[data-v-222127ce],table thead[data-v-222127ce],table tr[data-v-222127ce]{padding:.5rem;border:1px solid;border-color:inherit}", ""]);

// exports
